export default __webpack_public_path__ + "static/media/origin.007edf84.svg";